import { Account } from '@/models/account';

const hasProfilePhoto = (account: Account | null): boolean => {
  if (!account) return false;
  return !!(account.originalPhoto || account.croppedPhoto);
};

export default hasProfilePhoto;
